import { useEffect } from 'react';

export default (currentStep, setStep) => {
  useEffect(() => {
    const handlePopstate = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const urlStep = urlParams.get('step');

      if (urlStep && urlStep !== currentStep) {
        setStep(urlStep);
      }
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, [currentStep]);
};
